/**
 * Generated country route paths — all English + translated slugs
 * Used by App.tsx to register all country landing page routes dynamically.
 */
import { getAllCountrySlugs } from '@/data/country-slug-translations';

/** All unique country page slugs (English + 10 Latin-script languages) */
export const ALL_COUNTRY_ROUTE_SLUGS = getAllCountrySlugs();
